import React from 'react';
import './styles/index.scss';
import Router from './router';

const App: React.FC = () => (
    <div className="__app">
        <Router />
    </div>
);

export default App;